import Http from "../../../../../core/http-axios-react/http/Http";
import { HttpBaseResponse } from "../../../../../core/HttpResponse";
import { M_InvoiceConstant } from "../../../type/Invoice.type";

export const getInvoiceConstant = async () => {
  const result = await Http.get<HttpBaseResponse<M_InvoiceConstant>>({
    url: "/invoice/constant",
  });
  return result;
};
